module.exports = __webpack_public_path__ + "img/tocg.cbfbae8b.png";